// extracted by mini-css-extract-plugin
module.exports = {"level_0":"CommentsSection_level_0__OFHwL","level_1":"CommentsSection_level_1__E7C4M","level_2":"CommentsSection_level_2__2ixSI","level_3":"CommentsSection_level_3__3QX0k"};